export default "__VITE_ASSET__b4414a9d__"